import { tableAnatomy as o } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as a, defineStyle as r } from "@chakra-ui/react";
const { defineMultiStyleConfig: n, definePartsStyle: e } = a([
  ...o.keys,
  "status",
  "container",
  "headerContainer",
  "headerContent",
  "headerActions",
  "rowSelectionContainer",
  "paginationContainer",
  "paginationSize",
  "paginationButtons",
  "dragColumnButton"
]), t = r({
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}), d = e({
  container: {
    position: "relative",
    border: "1px solid var(--sgi-colors-gray-200)",
    borderRadius: "lg"
  },
  headerContainer: {
    borderTopRadius: "lg",
    backgroundColor: "white",
    paddingX: { base: 0, md: 6 },
    paddingY: { base: 0, md: 5 },
    minHeight: { base: "68px", md: "72px" }
  },
  headerContent: {
    gap: { base: 2, md: 4 },
    alignItems: { base: "flex-start", md: "center" },
    flexDirection: { base: "column", md: "row" },
    justifyContent: "space-between",
    paddingTop: { base: 4, md: 0 },
    paddingX: { base: 4, md: 0 }
  },
  headerActions: {
    justifyContent: "flex-end",
    marginBottom: { base: 4, md: 0 },
    width: "100%",
    gap: { base: 2, md: 3 }
  },
  rowSelectionContainer: {
    zIndex: "banner",
    backgroundColor: "gray.100",
    borderRadius: "lg",
    paddingX: 3,
    paddingY: 2,
    gap: 2,
    width: { base: "100%", md: "calc(100% - 48px)" },
    position: "absolute",
    flexDir: { base: "column", md: "row" },
    justifyContent: "space-between",
    alignItems: { md: "center" }
  },
  paginationContainer: {
    gap: 2,
    flexDirection: { base: "column", md: "row" },
    justifyContent: "space-between",
    paddingY: 3,
    paddingX: 6,
    backgroundColor: "white",
    borderBottomRadius: "lg"
  },
  paginationSize: {
    alignItems: "center",
    justifyContent: { base: "space-between", md: "flex-start" },
    gap: 2
  },
  paginationButtons: {
    gap: 6,
    justifyContent: { base: "space-between", md: "flex-start" },
    alignItems: "center"
  },
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    textStyle: "bodyBold",
    textAlign: "left",
    whiteSpace: "pre-wrap",
    verticalAlign: "bottom",
    userSelect: "none"
  },
  thead: {
    tr: {
      backgroundColor: "gray.100"
    }
  },
  tbody: {
    td: {
      backgroundColor: "white"
    }
  },
  tfoot: {
    td: {
      textStyle: { base: "bodyBold", md: "bodyBoldSmall" },
      backgroundColor: "teal.25"
    }
  },
  td: {
    whiteSpace: "pre-wrap",
    textStyle: { base: "subheading2", md: "bodySmall" },
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "body",
    textAlign: "center",
    fontWeight: "medium"
  },
  status: {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    border: "0px",
    overflow: "hidden"
  },
  dragColumnButton: {
    cursor: "grab",
    _hover: {},
    // clear out hover styles
    _active: {}
    // clear out active styles
  }
}), p = n({
  baseStyle: d,
  variants: {
    base: e(({ theme: i }) => ({
      th: {
        borderBottom: "1px",
        borderTop: "1px",
        borderColor: "gray.200",
        backgroundColor: "gray.50",
        ...t
      },
      tr: {
        _first: {
          td: {
            borderTop: "1px",
            borderColor: "gray.200"
          }
        },
        "&[data-selected=true]": {
          backgroundColor: "teal.25"
        },
        "&[data-table-row-expander=true] > td": {
          background: "teal.25",
          borderBottomWidth: "1px"
        },
        "&[data-table-row-expander=true]:last-of-type > td": {
          borderBottomWidth: "0px"
        }
      },
      td: {
        borderColor: "gray.200",
        ...t
      },
      caption: {
        color: "gray.600"
      },
      tfoot: {
        tr: {
          borderColor: "gray.200",
          "&:last-of-type": {
            th: { borderBottomWidth: 0 }
          }
        }
      }
    }))
  },
  sizes: {
    md: e({
      th: {
        px: { base: 4, md: 6 },
        py: 3
      },
      td: {
        px: { base: 4, md: 6 },
        py: { base: 2, md: 5 },
        lineHeight: "1"
      },
      caption: {
        px: "6",
        py: "2",
        fontSize: "sm"
      }
    })
  },
  defaultProps: {
    variant: "base",
    size: "md"
  }
});
export {
  p as default
};
